import React, { useContext, VFC } from 'react';

import classNames from 'classnames';
import { Grid } from 'mintel-react-ui';

import { useColsCollapsed, GRID_BASE_WIDTH, LAYOUT } from '/components/common';
import { BlockColumnsProps } from '/types';
import { PresentModeContext } from '/utils/contexts';

import styles from './BlockColumns.scss';

const GetLaptopWidth = (
  idx: number,
  numColumns: number,
  layout: string,
  fullWidth: boolean,
): number => {
  if (fullWidth) {
    return GRID_BASE_WIDTH;
  }
  if (
    (idx == 0 && layout === LAYOUT.LEFT) ||
    (idx == numColumns - 1 && layout === LAYOUT.RIGHT)
  ) {
    return (2 * GRID_BASE_WIDTH) / 3;
  }
  if (layout != LAYOUT.EQUAL) {
    return GRID_BASE_WIDTH / 3;
  }
  return GRID_BASE_WIDTH / numColumns;
};

const BlockColumns: VFC<BlockColumnsProps> = ({
  columnComponents,
  layout,
  columnWidth,
  rowCenterAlign = false,
  presentCenterAlignDisabled = false,
}) => {
  const presentMode = useContext(PresentModeContext);
  const colsCollapsed = useColsCollapsed();
  const columnWidthByDevice = {
    width: GRID_BASE_WIDTH,
    tablet: GRID_BASE_WIDTH,
  };
  const fullWidth = columnComponents.length === 1 && !!presentMode;

  return (
    <Grid
      className={classNames(styles['block-col-grid'], styles['no-padding'])}
    >
      <Grid.Row
        className={classNames(styles['grid-row'], {
          [styles['column-wrap']]: colsCollapsed,
          [styles['present-mode']]: !!presentMode,
          [styles['grid-row-center-aligned']]:
            rowCenterAlign || (!!presentMode && !presentCenterAlignDisabled),
        })}
      >
        {columnComponents.map((Column: JSX.Element, idx: number) => (
          <Grid.Col
            {...columnWidthByDevice}
            laptop={
              columnWidth ||
              GetLaptopWidth(idx, columnComponents.length, layout, fullWidth)
            }
            className={styles['grid-col']}
            key={idx}
          >
            {Column}
          </Grid.Col>
        ))}
      </Grid.Row>
    </Grid>
  );
};

export default BlockColumns;
